import { EXAM_ADMIN_PAGE_PATHS } from "@airange/shared/exam-routes";

export function sanitizeRedirectPath(
  rawValue: string | null | undefined,
  fallback = EXAM_ADMIN_PAGE_PATHS.dashboard,
) {
  const value = String(rawValue || "").trim();
  if (!value) return fallback;
  if (!value.startsWith("/") || value.startsWith("//")) return fallback;
  return value;
}
